module.exports = __webpack_public_path__ + "static/media/livewellfinder-header-bg.29efccb6.png";